module.exports = __webpack_public_path__ + "26ce72ebc57ca4d67c64ab311d1d23d6.png";